import "../../styles/about/aboutHero.css";

const AboutHero = () => {
  return (
    <section className="about-hero">
      <div className="about-hero-inner">
        <h1 className="about-hero-title">About VisualLab</h1>

        <p className="about-hero-subtitle">
          VisualLab is built to make complex concepts easier to understand
          through interactive visualizations and structured explanations.
        </p>

        <p className="about-hero-description">
          Whether you're learning data structures, algorithms, or core computer
          science topics, VisualLab helps you see how things work - not just
          read about them.
        </p>
      </div>
    </section>
  );
};

export default AboutHero;
